module.exports = __webpack_public_path__ + "img/logo9.bfcdfcc5.png";